import {Moment} from 'moment';
import {ICustomer} from "./customer.model";
import {IOrderObject} from "./order-object.model";

export interface ICustomerFile {
  id?: number;
  itemName?: string;
  type?: string;
  fileType?: string;
  size?: string;
  amazonDocId?: string;
  version?: number;
  expirationDate?: Moment;
  uploadBy?: string;
  approve?: boolean;
  isLastVersion?: boolean;
  status?: string;
  fileContentType?: string;
  file?: any;
  orderObject?: IOrderObject;
  customer?: ICustomer;
}

export class CustomerFile implements ICustomerFile {
  constructor(public id?: number,
              public itemName?: string,
              public type?: string,
              public fileType?: string,
              public size?: string,
              public amazonDocId?: string,
              public version?: number,
              public expirationDate?: Moment,
              public uploadBy?: string,
              public approve?: boolean,
              public isLastVersion?: boolean,
              public status?: string,
              public fileContentType?: string,
              public file?: any,
              public customer?: ICustomer) {
    this.approve = this.approve || false;
    this.isLastVersion = this.isLastVersion || false;
  }
}
